import { render, staticRenderFns } from "./Goin.vue?vue&type=template&id=aea7bcea&scoped=true&"
import script from "./Goin.vue?vue&type=script&lang=js&"
export * from "./Goin.vue?vue&type=script&lang=js&"
import style0 from "./Goin.vue?vue&type=style&index=0&id=aea7bcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea7bcea",
  null
  
)

export default component.exports